import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MarginCreate from './MarginCreate'
import MarginsList from './MarginsList'

import { getMargins, clearMargins } from '../../../modules/actions/margins'

import { selectedPartnershipIdSelector } from '../../../modules/selectors/partnerships'

import useCommonStyles from '../../../styles/common/listPage'

const Margins = () => {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)

  useEffect(() => {
    if (selectedPartnershipId) {
      dispatch(getMargins({ partnership: selectedPartnershipId }))
    }

    return () => {
      dispatch(clearMargins())
    }
  }, [dispatch, selectedPartnershipId])

  return (
    <>
      <div className={commonClasses.heading}>
        <h3 className={commonClasses.title}>{t('Margins')}</h3>
        <p>
          {t(
            'Manage the margins applied to this partnership. You can update the margins or create an override for a specific campaign.'
          )}
        </p>
        <p>
          {t(
            'Please note that if you update the margin, it will only apply to campaigns created from today onwards and the old margin will continue to apply to previously created campaigns (this is because it has already been reported so cannot be changed - if you would like to override this to make a margin update retrospectively please contact your account manager).'
          )}
        </p>
        <div className={commonClasses.formButtons}>
          <MarginCreate />
        </div>
      </div>
      <MarginsList />
    </>
  )
}

export default Margins
